import {ServiceBase} from "../ServiceBase";
import {IMenuItemActionFactoryService} from "./menu-item-action-factory.service.interface";
import {CustomMenuItemActionConstructorDefinition, IMenuItemAction} from "./menu-item-action.interface";
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IMenuItemConfigReader} from "../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {LinkNavigationAction} from "./link-navigation.action";
import {
    MenuItemDefaultConfigReader
} from "../menu-items-common/menu-item-config-reader/menu-item-default-config-reader";

export class MenuItemActionFactoryService extends ServiceBase implements IMenuItemActionFactoryService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        let actionsModules = require.context('./custom-actions', true, /.+\.action\.(ts|tsx)$/);

        this._customActionsModules = actionsModules.keys()
                                                  .map(actionsModules)
                                                  .map((module: any) => {
                                                      const ActionConstructor: CustomMenuItemActionConstructorDefinition = module.default;
                                                      const actionInstance = new ActionConstructor(new MenuItemDefaultConfigReader(this.services), this.services)
                                                      return {
                                                          actionKey: actionInstance.key,
                                                          actionConstructor: ActionConstructor
                                                      };
                                                  }).toDictionary(item => item.actionKey, item => item.actionConstructor);
    }

    private readonly _customActionsModules: Record<MenuItemKey, CustomMenuItemActionConstructorDefinition>;

    getMenuItemAction(key: MenuItemKey, configReader?: IMenuItemConfigReader): IMenuItemAction {

        configReader = configReader ?? new MenuItemDefaultConfigReader(this.services);

        const CustomActionConstructor = this._customActionsModules[key];
        if(CustomActionConstructor) {
            return new CustomActionConstructor(configReader, this.services);
        }

        return new LinkNavigationAction(key, configReader, this.services);
    }
}